import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import s from './campaignUser.module.css';

/**
 * Renders Campaign free-text (step/campaign descriptions, block leads, notes) authored in the Admin
 * builder as Markdown, inside the scoped runner design system.
 *
 * Admins type these values into plain `multiline` textboxes, so the stored string carries real
 * newlines and inline Markdown. Rendering it as bare text in a `<p>` collapsed the newlines (default
 * `white-space: normal`) and ignored the formatting. This component fixes both:
 *   - GFM Markdown (bold/italic/lists/links/tables/code) via `remark-gfm`.
 *   - Single carriage returns survive: react-markdown emits a soft line break as a `\n` text node,
 *     and `.markdown p { white-space: pre-line }` (see campaignUser.module.css) renders it as a break.
 *
 * `className` is applied to the wrapper alongside `.markdown`, so callers keep passing the typography
 * class the old `<p>` used (`ui.blockLead` / `ui.heroLead`); the wrapper's color/size/line-height
 * inherit down to the rendered Markdown. Renders nothing for empty/nullish input.
 */
const CampaignMarkdown: React.FC<{ children?: string | null; className?: string }> = ({
  children,
  className,
}) => {
  if (!children) return null;
  const cls = [s.markdown, className].filter(Boolean).join(' ');
  return (
    <div className={cls}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </div>
  );
};

export default CampaignMarkdown;
